import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { CSVLink } from 'react-csv'
import { generateStudentListCsvData } from './utils'

const ExportStudentListDialog = ({ open, setOpen, students }) => {
  const handleClose = () => setOpen(false)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Ready to download your student list?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Click Download to export your full student list as a CSV file. The
          file will automatically download to your device.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          component={CSVLink}
          variant="contained"
          color="primary"
          startIcon={<FileDownloadOutlinedIcon />}
          filename="student_list.csv"
          data={generateStudentListCsvData(students)}
          onClick={handleClose}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ExportStudentListDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default ExportStudentListDialog
